import { useStyleSheet } from '../../hooks/useStyleSheet';
import { IconStyleProps } from './Icon.types';

export const useStyles = ({ variant }: IconStyleProps) =>
  useStyleSheet(
    (theme) => ({
      icon: {
        cursor: variant === 'action' ? 'pointer' : undefined,
        transition: `fill ${theme.transitions.primary}`,
      },
    }),
    [variant],
  );
